import loadable from "@loadable/component";

const Gottcha = loadable(() => import("./Gottcha.page"));

export default { component: Gottcha };
